import { Directive, ElementRef, Input } from '@angular/core';
/**
 * A helper directive to focus buttons. You will only need this if using a custom template
 */
var FocusDirective = (function () {
    function FocusDirective(elm) {
        this.elm = elm;
    }
    FocusDirective.prototype.ngOnChanges = function (changes) {
        if (changes.mwlFocus && this.mwlFocus === true) {
            this.elm.nativeElement.focus();
        }
    };
    FocusDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[mwlFocus]'
                },] },
    ];
    /** @nocollapse */
    FocusDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    FocusDirective.propDecorators = {
        'mwlFocus': [{ type: Input },],
    };
    return FocusDirective;
}());
export { FocusDirective };
//# sourceMappingURL=focus.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-confirmation-popover/dist/esm/src/focus.directive.js
// module id = 260
// module chunks = 9